// Side-effect module: initializes Sentry during ESM dependency evaluation.
// Import this FIRST in every entrypoint — ES module imports are hoisted and
// their modules evaluate in declaration order, so with this import first the
// global error handlers install BEFORE any other imported module evaluates,
// and a top-level throw in those modules (a broken component, a bad refactor)
// is reported instead of silently killing the page with Sentry never loaded.
import { initSentry } from './sentry';

initSentry();
